import React from "react";
import classNames from "classnames";
import { DateTime } from "luxon";
import { Context } from "@scenes/workloads/context";
import { isBlocked, isDone } from "../utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Task({
  element,
  constraints,
  hasOvertime,
  isHovered,
  onClick,
  onMouseDown,
  onMouseMove,
  onTouchStart,
  onTouchMove,
}: Props) {
  const { areDerivationsToggled } = React.useContext(Context);
  const withStartDate = !!element.startDate && !element.endDate;
  const withEndDate = !element.startDate && !!element.endDate;
  const completionOnEndDate =
    !!element.completionDate &&
    !!element.endDate &&
    DateTime.fromISO(element.completionDate, { zone: "utc" }).hasSame(
      DateTime.fromISO(element.endDate, { zone: "utc" }),
      "day",
    );

  return (
    <div
      className={classNames(styles.task, {
        [styles.unScheduled]: !element.startDate || !element.endDate,
        [styles.withStartDate]: withStartDate,
        [styles.withEndDate]: withEndDate,
        [styles.late]: hasOvertime,
        [styles.completed]: isDone(element),
        [styles.blocked]: isBlocked(element, constraints),
        [styles.hovered]: isHovered,
        [styles.derived]: areDerivationsToggled,
        [styles.completedAtEndDate]: completionOnEndDate,
      })}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
    />
  );
}

export { Task };
